import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter } from 'rxjs/operators'
import { Locale } from '@core/i18n/locale.enum'
import { ProfileStore } from '@core/store/profile/profile.store'
import { I18nStore } from '@core/i18n/state/i18n.store'
import { TranslateService } from '@ngx-translate/core'

export const initTranslateModule = () => {
  const profileStore = inject(ProfileStore)
  const i18nStore = inject(I18nStore)
  const translate = inject(TranslateService)

  translate.use(Locale.En)

  toObservable(profileStore.profileLang)
    .pipe(filter((lang) => !!lang))
    .subscribe((lang) => i18nStore.fetchTranslations(lang))
}
